import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';
import type { TeamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';
import { nameResolver } from '@/_shared';

import { useGetTeamMembersMutation } from '../apis';

export function TeamMembersAsyncSelect({
  disabled,
  menuPortalTarget,
  ...props
}: FormComboboxProps<TeamMemberQueryLinkerSchema> & { menuPortalTarget?: HTMLElement | null }) {
  const getName = useCallback(
    (item?: TeamMemberQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = nameResolver(item.first_name, item.last_name, '');

      if (!disabled) {
        return itemName;
      }
      return (
        <PrimaryLink to="/team-members/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString()}
      useApi={useGetTeamMembersMutation}
      disabled={disabled}
      menuPortalTarget={menuPortalTarget}
    />
  );
}
